import { useState, useEffect } from 'react';
import { listenToDocument } from '../services/firestore.service';

export const useUserProfile = (userId) => {
  const [profile, setProfile] = useState(null);
  const [portfolioSummary, setPortfolioSummary] = useState(null);
  const [carbonWallet, setCarbonWallet] = useState(null);
  const [settings, setSettings] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!userId) {
      setLoading(false);
      return;
    }

    setLoading(true);
    const unsubscribe = listenToDocument(
      'users',
      userId,
      (data) => {
        if (data) {
          setProfile(data.profile);
          setPortfolioSummary(data.portfolioSummary);
          setCarbonWallet(data.carbonWallet);
          setSettings(data.settings);
        } else {
          setProfile(null);
        }
        setLoading(false);
      },
      (err) => {
        setError(err);
        setLoading(false);
      }
    );

    return () => unsubscribe();
  }, [userId]);

  return { profile, portfolioSummary, carbonWallet, settings, loading, error };
};

